import { RootState } from "../../../redux-store";
import { createSelector } from "@reduxjs/toolkit";
import { selectMyTeams, selectTeams } from "../teams/selectors";

const selectStopUnitTemplatesData = (state: RootState) =>
  state.data.stopUnitTemplates;

export const selectAllStopUnitTemplates = createSelector(
  selectStopUnitTemplatesData,
  (templatesData) => templatesData.entities
);

export const selectActiveStopUnitTemplate = createSelector(
  selectAllStopUnitTemplates,
  (templates) => templates.filter((t) => !t.deleted)
);

export const selectMyTeamsStopUnitTemplates = createSelector(
  selectMyTeams,
  selectActiveStopUnitTemplate,
  (teams, templates) => {
    return templates.filter((t) =>
      t.teamsIds.some((teamId) => teams.some((team) => team.id === teamId))
    );
  }
);

export const selectTeamsForStopUnitTemplate = (templateId: string) =>
  createSelector(
    selectTeams,
    selectStopUnitTemplatesData,
    (allTeams, templatesData) => {
      const unitTemplate = templatesData.entities.find(
        (e) => e.id === templateId
      );
      if (!unitTemplate) {
        return [];
      }
      return allTeams.filter((team) => unitTemplate.teamsIds.includes(team.id));
    }
  );
